import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCart = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3 5.33398C3 4.7817 3.44772 4.33398 4 4.33398H6.66667C7.18387 4.33398 7.61573 4.72837 7.66256 5.24345L7.94352 8.33398H28C28.2899 8.33398 28.5655 8.45978 28.7555 8.67878C28.9454 8.89778 29.0309 9.18843 28.99 9.47541L27.8848 17.2116C27.6851 18.6097 26.5373 19.6791 25.1287 19.7797L10.0279 20.8583C8.39785 20.9748 6.97446 19.7651 6.82651 18.1376L5.75345 6.33398H4C3.44772 6.33398 3 5.88627 3 5.33398ZM8.12534 10.334L8.81829 17.9565C8.86761 18.499 9.34207 18.9022 9.88543 18.8634L24.9862 17.7848C25.4557 17.7513 25.8383 17.3948 25.9049 16.9288L26.847 10.334H8.12534ZM12.0013 23C10.7126 23 9.66797 24.0447 9.66797 25.3333C9.66797 26.622 10.7126 27.6667 12.0013 27.6667C13.29 27.6667 14.3346 26.622 14.3346 25.3333C14.3346 24.0447 13.29 23 12.0013 23ZM22.6654 23C21.3767 23 20.332 24.0447 20.332 25.3333C20.332 26.622 21.3767 27.6667 22.6654 27.6667C23.954 27.6667 24.9987 26.622 24.9987 25.3333C24.9987 24.0447 23.954 23 22.6654 23Z",
		fill: "inherit"
	})
});
export default SvgCart;
